const LOCAL_API_PATH = '../api/';

module.exports = { LOCAL_API_PATH };
// Used also by webpack, therefore CommonJS syntax.
